import { Loader2 } from "lucide-react";

export const FullPageLoader = ({ label = "Loading" }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
    <Loader2 className="w-10 h-10 text-cyan-400 animate-spin" style={{ color: "#00e5ff" }} />
    <p className="font-display text-sm tracking-widest text-slate-400 uppercase">{label}...</p>
  </div>
);

export const InlineLoader = ({ label }) => (
  <div className="flex items-center justify-center gap-3 py-10">
    <Loader2 className="w-6 h-6 animate-spin" style={{ color: "#00e5ff" }} />
    {label && <span className="text-slate-400 uppercase tracking-widest text-xs">{label}</span>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle, action }) => (
  <div className="glass rounded-2xl flex flex-col items-center justify-center text-center py-16 px-6">
    {Icon && (
      <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
        style={{ background: "rgba(0,229,255,0.08)", border: "1px solid rgba(0,229,255,0.25)" }}>
        <Icon className="w-8 h-8" style={{ color: "#00e5ff" }} />
      </div>
    )}
    <h3 className="font-display text-xl text-white mb-2">{title}</h3>
    {subtitle && <p className="text-slate-400 max-w-md mb-6">{subtitle}</p>}
    {action}
  </div>
);

export const PageHeader = ({ title, subtitle, right }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 animate-in-up">
    <div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-white uppercase tracking-wide">
        {title}
      </h1>
      {subtitle && <p className="text-slate-400 mt-2 text-base sm:text-lg">{subtitle}</p>}
    </div>
    {right}
  </div>
);

export const SectionCard = ({ children, className = "", ...props }) => (
  <div className={`glass glass-hover rounded-2xl p-6 ${className}`} {...props}>
    {children}
  </div>
);
